import React, { useEffect, useState } from "react";
import { Icon } from "@iconify/react/dist/iconify.js";
import { Link, NavLink, useLocation } from "react-router-dom";
import ThemeToggleButton from "../helper/ThemeToggleButton";

const MasterLayout = ({ children }) => {
  let [sidebarActive, seSidebarActive] = useState(false);
  let [mobileMenu, setMobileMenu] = useState(false);
  let [currentYear, setCurrentYear] = useState([]);
  let [user, setUser] = useState(null);
  const location = useLocation(); // Hook to get the current route

  const logout = () => {
    localStorage.clear();
    setTimeout(() => {
      window.location.href = '/login';
    }, 500);
  }

  useEffect(() => {
    setUser(JSON.parse(localStorage.getItem('user')))
    const currentYear = new Date().getFullYear(); // Get the year as a number
    setCurrentYear(currentYear);
    // Function to handle dropdown clicks
    const handleDropdownClick = (event) => {
      event.preventDefault();
      const clickedLink = event.currentTarget;
      const clickedDropdown = clickedLink.closest('.dropdown');

      if (!clickedDropdown) return;

      const isActive = clickedDropdown.classList.contains('open');

      // Close all dropdowns
      const allDropdowns = document.querySelectorAll('.sidebar-menu .dropdown');
      allDropdowns.forEach((dropdown) => {
        dropdown.classList.remove('open');
      });

      // Toggle the clicked dropdown
      if (!isActive) {
        clickedDropdown.classList.add('open');
      }
    };

    // Attach click event listeners to all dropdown triggers
    const dropdownTriggers = document.querySelectorAll('.sidebar-menu .dropdown > a, .sidebar-menu .dropdown > Link');

    dropdownTriggers.forEach((trigger) => {
      trigger.addEventListener('click', handleDropdownClick);
    });

    // Function to open submenu based on current route
    const openActiveDropdown = () => {
      const allDropdowns = document.querySelectorAll('.sidebar-menu .dropdown');
      allDropdowns.forEach((dropdown) => {
        const submenuLinks = dropdown.querySelectorAll('.sidebar-submenu li a');
        submenuLinks.forEach((link) => {
          if (link.getAttribute('href') === location.pathname || link.getAttribute('to') === location.pathname) {
            dropdown.classList.add('open');
          }
        });
      });
    };

    // Open the submenu that contains the open route
    openActiveDropdown();


    // Cleanup event listeners on unmount
    return () => {
      dropdownTriggers.forEach((trigger) => {
        trigger.removeEventListener('click', handleDropdownClick);
      });

    };
  }, [location.pathname]);


  let sidebarControl = () => {
    seSidebarActive(!sidebarActive);
  };

  let mobileMenuControl = () => {
    setMobileMenu(!mobileMenu);
  };

  const post = { padding: '8px', fontSize: '9px', background: '#4CAF50' }

  return (
    <section className={mobileMenu ? "overlay active" : "overlay "}>
      {/* sidebar */}
      <aside className={sidebarActive ? "sidebar active " : mobileMenu ? "sidebar sidebar-open" : "sidebar"}>
        <button onClick={mobileMenuControl} type="button" className="sidebar-close-btn">
          <Icon icon="radix-icons:cross-2" />
        </button>
        <div>
          <Link to="/dashboard" className="sidebar-logo">
            <img
              src="assets/images/alphaxcloud.png"
              alt="site logo"
              className="light-logo"
              width={280}
            />
            <img
              src="assets/images/alphaxcloud.png"
              alt="site logo"
              className="dark-logo"
              width={280}
            />
            <img
              src="assets/images/alphaxcloud.png"
              alt="site logo"
              className="logo-icon"
              width={280}
            />
          </Link>
        </div>
        <div className="sidebar-menu-area">
          <ul className="sidebar-menu" id="sidebar-menu">
            <li>
              <NavLink to="/dashboard" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="solar:home-smile-angle-outline" className="menu-icon" />
                <span>Dashboard</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/payments" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="hugeicons:money-send-square" className="menu-icon" />
                <span>Payments</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/instances" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="mage:email" className="menu-icon" />
                <span>Instances</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/devices" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="mdi:cellphone-link" className="menu-icon" />
                <span>Devices</span>
              </NavLink>
            </li>
            <li className="dropdown">
              <Link to="#">
                <Icon icon="bi:chat-dots" className="menu-icon" />
                <span>Messages</span>
              </Link>
              <ul className="sidebar-submenu ps-0">
                <li>
                  <NavLink to="/chat-single" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Chat
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/chat-image" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Image
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/chat-audio" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Audio
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/chat-video" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Video
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/chat-contact" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Contact
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/chat-location" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Location
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/chat-sms" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>SMS
                  </NavLink>
                </li>
                {/* <li>
                  <NavLink to="/chat-poll" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Poll
                  </NavLink>
                </li>
                <li>
                  <NavLink to="/chat-reply" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Reply
                  </NavLink>
                </li> */}
                <li>
                  <NavLink to="/chat-group" className={(navData) =>
                    navData.isActive ? "active-page" : ""
                  }>
                    <div className="badge" style={post}>POST</div>Send group
                  </NavLink>
                </li>
              </ul>
            </li>
            <li>
              <NavLink to="/templates" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="fe:vector" className="menu-icon" />
                <span>Templates</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/logs" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="mdi-file-document-outline" className="menu-icon" />
                <span>Manage Logs</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/phonebooks" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="mdi-contact-phone" className="menu-icon" />
                <span>Phonebook</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/campaigns" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="mdi-bullhorn" className="menu-icon" />
                <span>Campaigns</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/api-access" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="mdi-api" className="menu-icon" />
                <span>API Access</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/webhook-settings" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="mdi-cog" className="menu-icon" />
                <span>Webhook Setting</span>
              </NavLink>
            </li>
            <li>
              <NavLink to="/chat-messages" className={(navData) =>
                navData.isActive ? "active-page" : ""
              }>
                <Icon icon="mdi-message" className="menu-icon" />
                <span>Chat Messages</span>
              </NavLink>
            </li>
          </ul>
        </div>
      </aside>

      <main className={sidebarActive ? "dashboard-main active" : "dashboard-main"}>
        <div className="navbar-header">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-4">
                <button type="button" className="sidebar-toggle" onClick={sidebarControl}>
                  {
                    sidebarActive ? (<Icon
                      icon="iconoir:arrow-right"
                      className="icon text-2xl non-active"
                    />) : (<Icon
                      icon="heroicons:bars-3-solid"
                      className="icon text-2xl non-active "
                    />)
                  }
                </button>
                <button onClick={mobileMenuControl} type="button" className="sidebar-mobile-toggle">
                  <Icon
                    icon="heroicons:bars-3-solid"
                    className="icon"
                  />
                </button>
                <form className="navbar-search">
                  <input type="text" name="search" placeholder="Search" />
                  <Icon icon="ion:search-outline" className="icon" />
                </form>
              </div>
            </div>
            <div className="col-auto">
              <div className="d-flex flex-wrap align-items-center gap-3">
                {/* ThemeToggleButton */}
                <ThemeToggleButton />
                {/* Message dropdown end */}
                <div className="dropdown">
                  <button
                    className="has-indicator w-40-px h-40-px bg-neutral-200 rounded-circle d-flex justify-content-center align-items-center"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <Icon
                      icon="iconoir:bell"
                      className="text-success-light text-xl"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-lg p-0">
                    <div className="m-16 py-12 px-16 radius-8 bg-success-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-success-light fw-semibold mb-0">
                          Notifications
                        </h6>
                      </div>
                      <span className="text-success-600 fw-semibold text-lg w-40-px h-40-px rounded-circle bg-base d-flex justify-content-center align-items-center">
                        05
                      </span>
                    </div>
                    <div className="max-h-400-px overflow-y-auto scroll-sm pe-4">
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between"
                      >
                        <div className="text-black hover-bg-transparent hover-text-success d-flex align-items-center gap-3">
                          <span className="w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                            <Icon
                              icon="bitcoin-icons:verify-outline"
                              className="icon text-xxl"
                            />
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Congratulations
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                              Your profile has been Verified. Your profile has
                              been Verified
                            </p>
                          </div>
                        </div>
                        <span className="text-sm text-secondary-light flex-shrink-0">
                          23 Mins ago
                        </span>
                      </Link>
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between bg-neutral-50"
                      >
                        <div className="text-black hover-bg-transparent hover-text-success d-flex align-items-center gap-3">
                          <span className="w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                            <img
                              src="assets/images/notification/profile-1.png"
                              alt=""
                            />
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Ronald Richards
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                              You can stitch between artboards
                            </p>
                          </div>
                        </div>
                        <span className="text-sm text-secondary-light flex-shrink-0">
                          23 Mins ago
                        </span>
                      </Link>
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between"
                      >
                        <div className="text-black hover-bg-transparent hover-text-success d-flex align-items-center gap-3">
                          <span className="w-44-px h-44-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                            AM
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Arlene McCoy
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                              Invite you to prototyping
                            </p>
                          </div>
                        </div>
                        <span className="text-sm text-secondary-light flex-shrink-0">
                          23 Mins ago
                        </span>
                      </Link>
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between bg-neutral-50"
                      >
                        <div className="text-black hover-bg-transparent hover-text-success d-flex align-items-center gap-3">
                          <span className="w-44-px h-44-px bg-success-subtle text-success-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                            <img
                              src="assets/images/notification/profile-2.png"
                              alt=""
                            />
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Annette Black
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                              Invite you to prototyping
                            </p>
                          </div>
                        </div>
                        <span className="text-sm text-secondary-light flex-shrink-0">
                          23 Mins ago
                        </span>
                      </Link>
                      <Link
                        to="#"
                        className="px-24 py-12 d-flex align-items-start gap-3 mb-2 justify-content-between"
                      >
                        <div className="text-black hover-bg-transparent hover-text-success d-flex align-items-center gap-3">
                          <span className="w-44-px h-44-px bg-info-subtle text-info-main rounded-circle d-flex justify-content-center align-items-center flex-shrink-0">
                            DR
                          </span>
                          <div>
                            <h6 className="text-md fw-semibold mb-4">
                              Darlene Robertson
                            </h6>
                            <p className="mb-0 text-sm text-secondary-light text-w-200-px">
                              Invite you to prototyping
                            </p>
                          </div>
                        </div>
                        <span className="text-sm text-secondary-light flex-shrink-0">
                          23 Mins ago
                        </span>
                      </Link>
                    </div>
                    <div className="text-center py-12 px-16">
                      <Link
                        to="#"
                        className="text-success-600 fw-semibold text-md"
                      >
                        See All Notification
                      </Link>
                    </div>
                  </div>
                </div>
                {/* Notification dropdown end */}
                <div className="dropdown">
                  <button
                    className="d-flex justify-content-center align-items-center rounded-circle"
                    type="button"
                    data-bs-toggle="dropdown"
                  >
                    <img
                      src={`${process.env.REACT_APP_FILE_URL}/profile/${user?.image}`}
                      alt="image_user"
                      className="w-40-px h-40-px object-fit-cover rounded-circle"
                    />
                  </button>
                  <div className="dropdown-menu to-top dropdown-menu-sm">
                    <div className="py-12 px-16 radius-8 bg-success-50 mb-16 d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <h6 className="text-lg text-success-light fw-semibold mb-2">
                          {user?.name}
                        </h6>
                        <span className="text-secondary-light fw-medium text-sm">User</span>
                      </div>
                      <button type="button" className="hover-text-danger">
                        <Icon icon="radix-icons:cross-1" className="icon text-xl" />
                      </button>
                    </div>
                    <ul className="to-top-list">
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-success d-flex align-items-center gap-3"
                          to="/my-profile"
                        >
                          <Icon icon="solar:user-linear" className="icon text-xl" />
                          My Profile
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-success d-flex align-items-center gap-3"
                          to="/settings"
                        >
                          <Icon icon="solar:settings-outline" className="icon text-xl" />
                          Settings
                        </Link>
                      </li>
                      <li>
                        <Link
                          className="dropdown-item text-black px-0 py-8 hover-bg-transparent hover-text-danger d-flex align-items-center gap-3"
                          to="javascript:void(0)"
                          onClick={logout}
                        >
                          <Icon icon="lucide:power" className="icon text-xl" /> Log Out
                        </Link>
                      </li>
                    </ul>
                  </div>
                </div>
                {/* Profile dropdown end */}

              </div>
            </div>
          </div>
        </div>

        {/* dashboard-main-body */}
        <div className="dashboard-main-body">{children}</div>

        {/* Footer section */}
        <footer className="d-footer">
          <div className="row align-items-center justify-content-between">
            <div className="col-auto">
              <p className="mb-0">© {currentYear} AlphaXCloud. All Rights Reserved.</p>
            </div>
            <div className="col-auto">
              <p className="mb-0">
                Made by <span className="text-success-600">RCA</span>
              </p>
            </div>
          </div>
        </footer>
      </main>
    </section>
  );
};

export default MasterLayout;
